var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4843 8.07972C17.1978 8.07972 16.9686 8.31887 16.9686 8.6178V13.5124C16.9686 14.8437 15.9295 15.9238 14.6575 15.9238H3.34253C2.06664 15.9238 1.03141 14.8397 1.03141 13.5124V8.53809C1.03141 8.23915 0.802207 8 0.515705 8C0.229202 8 0 8.23915 0 8.53809V13.5124C0 15.4376 1.50127 17 3.34253 17H14.6575C16.5025 17 18 15.4336 18 13.5124V8.6178C18 8.32285 17.7708 8.07972 17.4843 8.07972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92571 4.24498L8.45606 1.797V12.4738C8.45606 12.7661 8.69781 13 9 13C9.30219 13 9.54394 12.7661 9.54394 12.4738V1.797L12.0743 4.24498C12.179 4.34633 12.3201 4.4009 12.4571 4.4009C12.5981 4.4009 12.7351 4.35022 12.8398 4.24498C13.0534 4.03838 13.0534 3.70705 12.8398 3.50045L9.38278 0.155922C9.28205 0.0584708 9.14102 0 9 0C8.85495 0 8.71796 0.0545727 8.61723 0.155922L5.16016 3.50045C4.94661 3.70705 4.94661 4.03838 5.16016 4.24498C5.36968 4.44768 5.71619 4.44768 5.92571 4.24498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.68021ac5537281b5ab0c58f0368a5f70.svg";
export { ForwardRef as ReactComponent };